import { Instance } from '../../../helpers/apiManager/instance';

const KEY = 'ts-waiting-room';

export function readQueue() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || 'null');
  } catch (error) {
    return null;
  }
}

export function rememberQueue(next) {
  const current = readQueue() || {};
  const events = { ...(current.events || {}) };
  if (next && next.eventId) {
    events[next.eventId] = { ...(events[next.eventId] || {}), ...next };
  }
  const activeId = (next && next.eventId) || current.eventId;
  const active = (activeId && events[activeId]) || next || {};
  sessionStorage.setItem(
    KEY,
    JSON.stringify({
      ...current,
      ...active,
      events,
    })
  );
}

export function hasCheckoutPass(eventId) {
  const saved = readQueue();
  const row = (saved && saved.events && saved.events[eventId]) || saved;
  return Boolean(
    row &&
      row.eventId === eventId &&
      row.passToken &&
      row.passExpires > Date.now()
  );
}

export function queueHeaders() {
  const saved = readQueue();
  if (!saved) {
    return {};
  }
  const active = sessionStorage.getItem('ts-event-gate-active');
  const row = (active && saved.events && saved.events[active]) || saved;
  return {
    ...(row.passToken ? { 'X-Queue-Pass': row.passToken } : {}),
    ...(row.payToken ? { 'X-Queue-Pay': row.payToken } : {}),
    ...(row.bookingSessionId ? { 'X-Queue-Session': row.bookingSessionId } : {}),
    ...(row.eventId ? { 'X-Queue-Event': row.eventId } : {}),
  };
}

let liveCache = { at: 0, on: true };

export async function waitingRoomIsOn() {
  if (Date.now() - liveCache.at < 10000) {
    return liveCache.on;
  }

  try {
    const body = await Instance.get('/v1/CheckoutGate/Live');
    liveCache = { at: Date.now(), on: body?.data?.on !== false };
  } catch (error) {
    liveCache = { at: Date.now(), on: true };
  }

  return liveCache.on;
}
